import { IContactFlag } from 'clickNgo/entities/contactFlag'
import { IContactFlagsAllDataView } from 'clickNgo/models/crud/views'

export const mapContactFlagFromContactFlagsAllData = (
  contactFlag: IContactFlagsAllDataView
): IContactFlag => ({
  created: contactFlag.Created,
  createdBy: contactFlag.CreatedBy,
  modified: contactFlag.Modified,
  modifiedBy: contactFlag.ModifiedBy,
  code: contactFlag.Code,
  contactId: contactFlag.ContactId,
  entryId: contactFlag.EntryId,
  partnerId: contactFlag.PartnerId,
  topPartnerId: contactFlag.TopPartnerId,
  type: contactFlag.Type,
  action: contactFlag.Action,
  caption: contactFlag.Caption,
  comment: contactFlag.Comment,
  country: contactFlag.Country,
  market: contactFlag.Market,
  notificationSendLog: contactFlag.NotificationSendLog,
  processedDate: contactFlag.Processed_Date,
  refEntryId: contactFlag.RefEntryId,
  requestStarted: contactFlag.RequestStarted,
  source: contactFlag.Source,
  status: contactFlag.Status,
  ageDays: contactFlag.AgeDays,
})
